import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, KeyIcon } from '@heroicons/react/24/outline';

const ResetPassword = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to login page since Firebase handles password reset through email
    navigate('/login');
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-blue-100">
            <KeyIcon className="h-6 w-6 text-blue-600" />
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-white">
            Password Reset
          </h2>
          <p className="mt-2 text-center text-sm text-gray-300">
            Please check your email for password reset instructions.
          </p>
        </div>
        
        <div className="mt-8 space-y-6">
          <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <KeyIcon className="h-5 w-5 text-blue-400" />
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-blue-800">
                  Check Your Email
                </h3>
                <div className="mt-2 text-sm text-blue-700">
                  <p>
                    We've sent you a password reset link. Please check your email and follow the instructions to reset your password.
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="text-center">
            <Link
              to="/login"
              className="inline-flex items-center text-sm font-medium text-blue-400 hover:text-blue-300"
            >
              <ArrowLeftIcon className="mr-2 h-4 w-4" />
              Back to Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;